import { Editor } from "slate";

import { removeSkippedElements } from "components/slate/plugins/serialization/withSerialize/removeSkippedElements";
import { getClipboardPlainText } from "components/slate/plugins/serialization/withSerialize/getClipboardPlainText";
import { patchCopiedClipboardHtml } from "components/slate/plugins/serialization/withSerialize/patchCopiedClipboardHtml";

export const getClipboardDataHtmlNode = (data: any) => {
  const clipboardNode = document.createElement("div");
  clipboardNode.innerHTML = data.getData("text/html");
  clipboardNode.setAttribute("hidden", "true");
  document.body.appendChild(clipboardNode);

  return clipboardNode;
};

export const withSerialize = (editor: Editor) => {
  const { setFragmentData } = editor;

  editor.setFragmentData = (data) => {
    setFragmentData(data);

    const clipboardNode = getClipboardDataHtmlNode(data);
    removeSkippedElements(clipboardNode);

    const plainText = getClipboardPlainText(clipboardNode);
    data.setData("text/plain", plainText);

    patchCopiedClipboardHtml(clipboardNode);
    data.setData("text/html", clipboardNode.innerHTML);

    document.body.removeChild(clipboardNode);
  };

  return editor;
};
